import { Tooltip } from 'antd'
import dayjs from 'dayjs'
import CustomSelect from 'features/Registration/components/CustomSelect'

export const ListCertificates = (props) => {
  const {
    selectedCertificates,
    registration,
    setRegistration,
    cerTypeOptions,
    setSelectedCertificates,
    screenAction,
    handleShowModalChooseSignMethod,
    changeCertType,
  } = props
  return (
    <div>
      <div
        className="d-flex align-items-end font-sfpro-bold"
        style={{ minHeight: '44px', paddingBottom: '8px' }}
      >
        5. Danh sách chứng thư số sử dụng
      </div>
      <div className="digital-certificate">
        <table className="table table-bordered">
          <thead>
            <tr role="row">
              <th scope="col" rowSpan="2" colSpan="1">
                STT
              </th>
              <th scope="col" rowSpan="2" colSpan="1">
                Tên tổ chức cơ quan chứng thực/cấp/công nhận chữ ký số, chữ ký
                điện tử
              </th>
              <th scope="col" rowSpan="2" colSpan="1">
                Số sê-ri chứng thư
              </th>
              <th scope="col" rowSpan="1" colSpan="2">
                Thời hạn sử dụng chứng thư số
              </th>
              <th scope="col" rowSpan="2" colSpan="1">
                Hình thức đăng ký (Thêm mới, gia hạn, ngừng sử dụng)
              </th>
              <th scope="col" rowSpan="2" colSpan="1" style={{ width: '70px' }}>
                {selectedCertificates.length == 0 &&
                  (!registration?.digital_certificates ||
                    registration?.digital_certificates?.length == 0) && (
                    <div>
                      <i
                        className="fal fa-plus mr-4 cursor-pointer mx-auto"
                        onClick={
                          screenAction != 'xem' &&
                          handleShowModalChooseSignMethod
                        }
                      ></i>
                    </div>
                  )}
              </th>
            </tr>
            <tr role="row">
              <th scope="col" rowSpan="1" colSpan="1">
                Từ ngày
              </th>
              <th scope="col" rowSpan="1" colSpan="1">
                Đến ngày
              </th>
            </tr>
          </thead>
          <tbody>
            {registration.digital_certificates?.map(
              (certificate, index, arr) => (
                <tr key={index}>
                  <th scope="row">{index + 1}</th>
                  <td>
                    <Tooltip title={certificate.issuedBy}>
                      <div
                        style={{
                          display: '-webkit-box',
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: 'vertical',
                          overflow: 'hidden',
                          wordBreak: 'break-word',
                        }}
                      >
                        {certificate.issuedBy}
                      </div>
                    </Tooltip>
                  </td>
                  <td>
                    <Tooltip title={certificate.idValue}>
                      <div
                        style={{
                          display: '-webkit-box',
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: 'vertical',
                          overflow: 'hidden',
                          wordBreak: 'break-word',
                        }}
                      >
                        {certificate.idValue}
                      </div>
                    </Tooltip>
                  </td>
                  <td>{dayjs(certificate.issuedDate).format('DD/MM/YYYY')}</td>
                  <td>{dayjs(certificate.expireDate).format('DD/MM/YYYY')}</td>
                  <td>
                    <CustomSelect
                      value={cerTypeOptions.find(
                        ({ value }) =>
                          value == certificate.registration_cert?.type,
                      )}
                      onChange={({ value }) =>
                        changeCertType('digital_certificates', index, value)
                      }
                      options={cerTypeOptions}
                    />
                  </td>
                  <td>
                    <div>
                      {!selectedCertificates?.length &&
                        index === arr.length - 1 && (
                          <i
                            className="fal fa-plus mr-4 cursor-pointer"
                            onClick={
                              screenAction != 'xem'
                                ? handleShowModalChooseSignMethod
                                : null
                            }
                          ></i>
                        )}
                      <i
                        className="far fa-trash-alt cursor-pointer"
                        onClick={() => {
                          setRegistration((old) => ({
                            ...old,
                            digital_certificates:
                              old.digital_certificates.filter(
                                (cer) => cer.idValue != certificate.idValue,
                              ),
                          }))
                        }}
                      ></i>
                    </div>
                  </td>
                </tr>
              ),
            )}
            {selectedCertificates.map((certificate, index, arr) => (
              <tr key={index}>
                <th scope="row">
                  {(registration?.digital_certificates?.length || 0) +
                    index +
                    1}
                </th>
                <td>
                  <Tooltip title={certificate.issuedBy}>
                    <div
                      style={{
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        wordBreak: 'break-word',
                      }}
                    >
                      {certificate.issuedBy}
                    </div>
                  </Tooltip>
                </td>
                <td>
                  <Tooltip title={certificate.idValue}>
                    <div
                      style={{
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        wordBreak: 'break-word',
                      }}
                    >
                      {certificate.idValue}
                    </div>
                  </Tooltip>
                </td>
                <td>{dayjs(certificate.issuedDate).format('DD/MM/YYYY')}</td>
                <td>{dayjs(certificate.expireDate).format('DD/MM/YYYY')}</td>
                <td>
                  <CustomSelect
                    value={cerTypeOptions.find(
                      ({ value }) => value == certificate?.type,
                    )}
                    onChange={({ value }) =>
                      changeCertType('selectedCertificates', index, value)
                    }
                    options={cerTypeOptions}
                  />
                </td>
                <td>
                  <div>
                    {index === arr.length - 1 && (
                      <i
                        className="fal fa-plus mr-4 cursor-pointer"
                        onClick={
                          screenAction != 'xem' &&
                          handleShowModalChooseSignMethod
                        }
                      ></i>
                    )}
                    <i
                      className="far fa-trash-alt cursor-pointer"
                      onClick={() =>
                        setSelectedCertificates((old) =>
                          old.filter(
                            (cer) => cer.idValue != certificate.idValue,
                          ),
                        )
                      }
                    ></i>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
